module.exports = __webpack_public_path__ + "static/media/money-check-alt.75ce712c.svg";